import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import ArticlePage from "@/pages/ArticlePage";
import CategoryPage from "@/pages/CategoryPage";
import PodcastPage from "@/pages/PodcastPage";
import SearchPage from "@/pages/SearchPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import ReadingListPage from "@/pages/ReadingListPage";
import HospitalsPage from "@/pages/HospitalsPage";
import AdvertisePage from "@/pages/AdvertisePage";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import ArticleManager from "@/pages/admin/ArticleManager";
import ArticleEditor from "@/pages/admin/ArticleEditor";
import CategoryManager from "@/pages/admin/CategoryManager";
import DoctorManager from "@/pages/admin/DoctorManager";
import PodcastManager from "@/pages/admin/PodcastManager";
import JobManager from "@/pages/admin/JobManager";
import VideoManager from "@/pages/admin/VideoManager";
import SettingsPage from "@/pages/admin/SettingsPage";
import BreakingNewsManager from "@/pages/admin/BreakingNewsManager";
import NewsletterPage from "@/pages/admin/NewsletterPage";
import AnalyticsPage from "@/pages/admin/AnalyticsPage";
import "@/App.css";

function App() {
  return (
    <HelmetProvider>
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="top-right" />
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<><Header /><HomePage /><Footer /></>} />
          <Route path="/article/:id" element={<><Header /><ArticlePage /><Footer /></>} />
          <Route path="/category/:slug" element={<><Header /><CategoryPage /><Footer /></>} />
          <Route path="/podcast/:id" element={<><Header /><PodcastPage /><Footer /></>} />
          <Route path="/search" element={<><Header /><SearchPage /><Footer /></>} />
          <Route path="/login" element={<><Header /><LoginPage /><Footer /></>} />
          <Route path="/register" element={<><Header /><RegisterPage /><Footer /></>} />
          <Route path="/bookmarks" element={<><Header /><ReadingListPage /><Footer /></>} />
          <Route path="/hospitals" element={<><Header /><HospitalsPage /><Footer /></>} />
          <Route path="/advertise" element={<><Header /><AdvertisePage /><Footer /></>} />

          {/* Admin routes */}
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="articles" element={<ArticleManager />} />
            <Route path="articles/new" element={<ArticleEditor />} />
            <Route path="articles/:id/edit" element={<ArticleEditor />} />
            <Route path="categories" element={<CategoryManager />} />
            <Route path="doctors" element={<DoctorManager />} />
            <Route path="podcasts" element={<PodcastManager />} />
            <Route path="jobs" element={<JobManager />} />
            <Route path="videos" element={<VideoManager />} />
            <Route path="breaking-news" element={<BreakingNewsManager />} />
            <Route path="newsletter" element={<NewsletterPage />} />
            <Route path="analytics" element={<AnalyticsPage />} />
            <Route path="settings" element={<SettingsPage />} />
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
